import React, { FC } from 'react';
import { Toolbar } from '@mui/material';
import './MobileSidebar.scss';
import { MobileLangSelect } from './MobileLangSelect';
import { SideBar } from './Sidebar';
import { CustomDrawer } from '../../CustomDrawer';
import { WalletCard } from '../../../homeParts/WalletCard';
import { headerNewsAvailable } from '../../../../constants/configuration';
import { BannerAppState, ScreenSize } from '../../../../models/Common';

interface MobileSidebarProps {
  isOpen: boolean;
  handleLanguage: (selected: string) => void;
  availableLanguages: string[];
  selectedLanguage: string;
  handleLogout: () => void;
  handleCloseSideBar: () => void;
  handleStartTour: () => void;
  isAuth: boolean;
  handleBrizTv: () => void;
  isShownBanner: BannerAppState;
  width: number;
}

export const MobileSidebar: FC<MobileSidebarProps> = ({
  isOpen,
  handleLanguage,
  availableLanguages,
  selectedLanguage,
  handleLogout,
  handleCloseSideBar,
  handleStartTour,
  isAuth,
  handleBrizTv,
  isShownBanner,
  width,
}) => {
  const bannerStyle =
    !headerNewsAvailable && !isAuth && width < ScreenSize.Tablet && isShownBanner === 'opened' && 'banner';
  const newsStyle =
    headerNewsAvailable && !(!isAuth && width < ScreenSize.Tablet && isShownBanner === 'opened') && 'news';
  const newsAndBannerStyle =
    headerNewsAvailable && !isAuth && width < ScreenSize.Tablet && isShownBanner === 'opened' && 'news-banner';
  const additionalInfo = newsAndBannerStyle || newsStyle || bannerStyle || '';

  return (
    <CustomDrawer isOpen={isOpen} handleClose={handleCloseSideBar}>
      <Toolbar />
      <div className={`mobile-sidebar content ${isAuth ? 'auth' : ''}`}>
        <div className={`mobile-sidebar__wallet ${additionalInfo}`}>
          <MobileLangSelect
            handleLanguage={handleLanguage}
            availableLanguages={availableLanguages}
            selectedLanguage={selectedLanguage}
          />
          {isAuth ? <WalletCard handleClose={handleCloseSideBar} /> : null}
        </div>
        <SideBar
          handleLogout={handleLogout}
          isAuth={isAuth}
          handleBrizTv={handleBrizTv}
          handleClose={handleCloseSideBar}
          handleRunTour={handleStartTour}
        />
      </div>
    </CustomDrawer>
  );
};
